if (!customElements.get('cl2-hero-media-b')) {
  customElements.define('cl2-hero-media-b', class extends HTMLElement {
    connectedCallback() {
      this.breakpoint = window.matchMedia('(min-width: 768px)');
      this.update = () => {
        this.querySelector(':scope > video')?.remove();
        const template = this.querySelector(`template[data-device="${this.breakpoint.matches ? 'desktop' : 'mobile'}"]`);
        const video = template?.content.querySelector('video')?.cloneNode(true);
        const picture = this.querySelector('picture');
        picture.hidden = Boolean(video);
        if (video) {
          video.muted = true;
          video.playsInline = true;
          this.append(video);
          video.play().catch(() => { /* Poster remains visible if autoplay is blocked. */ });
        }
      };
      this.breakpoint.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.breakpoint?.removeEventListener('change', this.update);
      this.querySelector(':scope > video')?.pause();
    }
  });
}
